export default __webpack_public_path__ + "static/media/bg-4of4.782e1cf5.svg";